import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Icon from 'srcReact/components/icons/Icon'
import { checkNested } from 'srcReact/helpers/validator'
import Button from '../Button'
import Spinner from '../Spinner'
import SuspendText from '../SuspendText'
import styles from './styles.module.scss'

function SuspendSection({
  objectType,
  objectId,
  instruction,
  status,
  mixrData,
  handleReinstate,
  handleEdit,
  handleDelete
}) {
  const { t } = useTranslation()
  const [reinstateSuccess, setReinstateSuccess] = useState(false)
  const {
    moderationReport: { reinstate }
  } = useSelector((state) => state)

  useEffect(() => {
    if (checkNested(reinstate, 'data', 'action', 'reinstate_request') && reinstate.data.action.reinstate_request) {
      setReinstateSuccess(true)
    }
  }, [reinstate && reinstate.data])

  return (
    <div className={styles.suspendContainer}>
      <SuspendText
        text={
          status === 'suspended_awaiting_review' || reinstateSuccess
            ? t('moderationReport.suspend.awaitingReview', { object: objectType })
            : t('moderationReport.suspend.objSuspended', { object: objectType })
        }
      />
      {status !== 'suspended_awaiting_review' && !reinstateSuccess && (
        <React.Fragment>
          {mixrData && mixrData()}
          <label className={styles.lblInstruction}>
            {t('moderationReport.suspend.instruction', { object: objectType })}
          </label>
          <div className={styles.instruction}>{instruction}</div>
          <div className={styles.warning}>{t('moderationReport.suspend.instruction2')}</div>
          {reinstate && reinstate.loading && <Spinner />}
          <div className={styles.buttons}>
            <Button text={t('moderationReport.suspend.askReinstate')} handleClick={handleReinstate} />
            <Button
              style='secondary'
              text={objectType === 'group' ? t('groupHome.options.editGroup') : t('mixrHome.moreOptions.editMixr')}
              handleClick={handleEdit}
              iconPosition='end'
              icon={<Icon name='edit' />}
            />
            <Button
              style='secondary'
              text={objectType === 'group' ? t('groupHome.options.deleteGroup') : t('mixrHome.moreOptions.cancelMixr')}
              handleClick={handleDelete}
              iconPosition='end'
              icon={<Icon name='delete' />}
            />
          </div>
        </React.Fragment>
      )}
    </div>
  )
}

export default SuspendSection
